import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthService, EnumRouteName, LANG_SIGNAL, LsLogoComponent } from '@lyricstream/shared';
import { environment } from '@src/environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { LangPickerComponent } from '../lang-picker/lang-picker.component';
import { AnalyticsConsentService } from '../../../core/services/analytics-consent.service';

@Component({
  selector: 'ls-footer',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, LsLogoComponent, LangPickerComponent, TranslateModule],
  templateUrl: './app-footer.component.html',
  styleUrl: './app-footer.component.scss',
})
export class AppFooterComponent {
  readonly year = new Date().getFullYear();
  env = environment;
  routeName = EnumRouteName;

  private readonly langSignal = inject(LANG_SIGNAL, { optional: true });
  protected readonly authService = inject(AuthService);
  protected readonly consent = inject(AnalyticsConsentService);

  getLangValue(): string {
    return this.langSignal?.() ?? 'fr';
  }
}
